export class ForbiddenError extends Error {
  code: number;

  constructor(message: string) {
    super(message);
    this.name = "Forbidden";
    this.code = 403;
  }
}
